import Core from "@/modules/core/service/Core";
import Common from "@/modules/dis/service/order/private/Common";

const url = {
    inspection: "/api/disposition/inspection/{0}/technician?user={1}",
    location  : "/api/disposition/order/{0}/location?user={1}"
}

export default {
    inspection (component, location, assignment, user, assignments) {
        if (!user) {
            return Promise.resolve();
        }

        Core.method.put(url.inspection, null, assignment.id, user.id).then(data => {
            Common.publishAssignments(
                component,
                assignment.order,
                location,
                [ data ],
                assignments
            );

            Core.message.hint(
                component,
                component.$t("disposition.inspection.technician.assigned",
                    [ assignment.unit.elevatorNo, user.name ]
                )
            );

            if (assignment.comment) {
                Core.message.popup(component, "disposition.inspection.comment");
            }
        }).catch(error => {
            Core.message.popup(component, error.id, error.parameter);
        });
    },

    location (component, location, order, user, assignments) {
        const query = component.$t("disposition.inspection.dispatchAll.query");
        const text  = component.$t("disposition.inspection.dispatchAll.text", [
            location.zip,
            location.city,
            location.street,
            location.contact,
            order.no
        ]);

        return Core.message.confirm(component, query, text, Core.message.Default, (confirmed) => {
            if (!confirmed) {
                return Promise.resolve();
            }

            Core.method.put(url.location, location, order.id, user.id).then(data => {
                if (data.find(unit => unit.comment)) {
                    Core.message.popup(component, "disposition.inspection.comment");
                }

                Common.publishAssignments(
                    component,
                    order,
                    location,
                    data,
                    assignments
                );

                Core.message.hint(component, component.$t("disposition.inspection.assignAll.success"));
            });
        });
    },
}